


















import { Component, Vue, Prop } from "vue-property-decorator";

import { Editor, EditorContent } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import TextAlign from "@tiptap/extension-text-align";
import Heading from "@tiptap/extension-heading";
import Document from "@tiptap/extension-document";
import TextStyle from "@tiptap/extension-text-style";
import FontFamily from "@tiptap/extension-font-family";
import Color from "@tiptap/extension-color";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import { FontSize } from "./extensions/fontsize";

import MenuBar from "./MenuBar.vue";
import { Photo } from "@/models";

@Component({
  components: {
    EditorContent,
    MenuBar
  }
})
export default class extends Vue {
  public editr: Editor;

  @Prop({ default: "" }) public content: string;
  @Prop() headers: Photo[];
  @Prop() footers: Photo[];
  @Prop({ default: false }) nomenu: boolean;
  @Prop({ default: false }) nofooter: boolean;
  @Prop({ default: true }) fontcontrolvisible: boolean;
  @Prop({ default: false }) isattachmentlink: boolean;
  @Prop({ default: "" }) public getattachmentlink: string;

  public init() {
    let menubar: any = this.$refs.menubar as any;
    menubar.init();
  }
  /**
   * Run init() on mounted...
   */
  public mounted() {
    this.init();
  }

  get editor(): Editor {
    if (!this.editr) {
      this.editr = new Editor({
        content: this.content,
        onUpdate: ({ editor }) => {
          const html = editor.getHTML();
          this.$emit("update", html);
        },
        onBlur: ({ editor }) => {
          const html = editor.getHTML();
          this.$emit("blur", html);
        },
        editorProps: {
          attributes: {
            class: "onecentraleditor"
          }
        },
        extensions: [
          Document,
          Text,
          Paragraph,
          StarterKit,
          Heading,
          TextAlign.configure({
            types: ["heading", "paragraph"],
            alignments: ["left", "right", "center", "justify"]
          }),
          TextStyle,
          FontFamily.configure({
            types: ["textStyle"]
          }),
          FontSize,
          Color.configure({
            types: ["textStyle"]
          }),
          Image.configure({
            inline: true,
            allowBase64: true
          }),
          Link.configure({
            openOnClick: true, // optional
            protocols: ["https"] // optional
          })
        ]
      });
    }
    return this.editr;
  }
  set editor(editr: Editor) {
    this.editr = editr;
  }

  public beforeUnmount(): void {
    this.editor.destroy();
  }
}
